import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";

export default function Accessibility() {
  return (
    <div>
      <HeroSection
        title="Accessibility Statement"
        description="Our commitment to accessible experiences for everyone."
        showSearchBar={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <PageHeader title="Accessibility Statement" />

        <div className="mt-6 space-y-4 text-sm text-gray-600 leading-relaxed">
          <p>
            Toucan is committed to ensuring digital accessibility for all users.
          </p>

          <p>
            Toucan continuously works to improve usability and comply with
            accessibility standards.
          </p>

          <p>
            Contact:{" "}
            <a
              href="mailto:support@booktoucan.com"
              className="underline text-[#1FADC6]"
            >
              support@booktoucan.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
